import React, { ComponentProps, FunctionComponent } from 'react';
import { ORDER_SUMMARY_TITLE } from '../../constants';
import './pane.scss';
import { PaneContent } from './PaneContent';

export const Pane: FunctionComponent<
    ComponentProps<typeof PaneContent> & {
        eventTitle: string;
    }
> = (props) => {
    const { eventImageSrc, eventTitle } = props;

    const eventImage = eventImageSrc ? (
        <div className="ticket-page--event-image-container eds-show-up-mn">
            <img
                className="ticket-page--event-image eds-max-img"
                alt={eventTitle}
                src={eventImageSrc}
                data-testid="ticket-page-image"
            />
            <div className="ticket-page--event-image-padding-fix" />
        </div>
    ) : null;

    return (
        <aside
            id="order-summary"
            aria-label={ORDER_SUMMARY_TITLE.toString()}
            className="eds-collapsible-pane-layout__content checkout-widget__ticket-page--pane-content"
        >
            {eventImage}
            <PaneContent {...props} />
        </aside>
    );
};

export default Pane;
